import { defineComponent as t, createBlock as s, openBlock as n, unref as o, withCtx as a, createVNode as l } from "vue";
import { ScalarModal as r } from "@scalar/components";
import c from "./TypesenseSearch.vue.js";
const d = /* @__PURE__ */ t({
  __name: "Search",
  props: {
    modalState: {},
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  setup(e) {
    return (y, p) => (n(), s(o(r), {
      "aria-label": "Reference Search",
      state: e.modalState,
      variant: "search"
    }, {
      default: a(() => [
        l(c, {
          typesenseCollection: e.typesenseCollection,
          typesenseHost: e.typesenseHost,
          typesenseKey: e.typesenseKey
        }, null, 8, ["typesenseCollection", "typesenseHost", "typesenseKey"])
      ]),
      _: 1
    }, 8, ["state"]));
  }
});
export {
  d as default
};
